import { CONTACT_EMAIL, SERVICE_AREA } from "@/lib/constants";


export default function FinalCTA() {
  return (
    <section
      data-testid="final-cta-section"
      className="section relative overflow-hidden"
      style={{
        background:
          "linear-gradient(180deg, hsl(var(--cream)) 0%, hsl(var(--rose)/0.22) 100%)",
      }}
    >
      <div className="mx-auto max-w-3xl text-center relative">
        <div className="absolute -top-6 left-1/2 -translate-x-1/2 font-script text-3xl text-[hsl(var(--rose-deep))]">
          ~ come to the table ~
        </div>
        <h2 className="mt-8 font-serif-display text-3xl sm:text-4xl lg:text-5xl text-[hsl(var(--brown))]">
          Bring a meaningful table to your{" "}
          <span className="italic text-[hsl(var(--rose-deep))]">next</span>{" "}
          gathering.
        </h2>
        <p className="mt-5 text-[hsl(var(--brown-soft))]">
          Tell us about your event, your guests, and the kind of food
          experience you want to create. We serve {SERVICE_AREA}.
        </p>
        <a
          href="#quote"
          data-testid="final-cta-button"
          className="btn-pill btn-primary mt-8 text-sm"
        >
          Request Catering Quote
          <span aria-hidden>→</span>
        </a>
        <p className="mt-5 text-sm text-[hsl(var(--brown-soft))]">
          Or email us directly at{" "}
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            data-testid="final-cta-email-link"
            className="font-semibold text-[hsl(var(--rose-deep))] hover:text-[hsl(var(--brown))] underline-offset-4 hover:underline"
          >
            {CONTACT_EMAIL}
          </a>
        </p>
      </div>
    </section>
  );
}
